import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { useToastStore } from '@shared/hooks/useToastStore';

/** Renders stacked toast notifications from the toast store. */
export default function ToastProvider() {
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  return (
    <>
      {toasts.map((toast, index) => (
        <Snackbar
          key={toast.id}
          open
          autoHideDuration={toast.autoHideDuration ?? 6000}
          onClose={() => removeToast(toast.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ bottom: { xs: 24 + index * 64 } }}
        >
          <Alert
            onClose={() => removeToast(toast.id)}
            severity={toast.severity}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {toast.message}
            {toast.correlationId && (
              <Typography variant="caption" display="block" sx={{ opacity: 0.8, mt: 0.5 }}>
                Ref: {toast.correlationId}
              </Typography>
            )}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}
